export const SUBMIT = 'PROFILE/SUBMIT'
